import type { ICard } from "@app/dashboard/types/innerLayout/cards";
import styles from "./card.module.scss";

export const Card = ({
  width = "fit-content",
  height = "fit-content",
  title,
  onClickHandler,
  children,
}: ICard) => {
  return (
    <div
      className={styles["card"]}
      style={{ width, height }}
      onClick={onClickHandler}
    >
      {
        title &&
        <div className={styles["card__title"]}>
          {title}
        </div>
      }
      <div className={styles["card__body"]}>
        {children}
      </div>
    </div>
  )
};